import {Checkbox} from '@radix-ui/react-checkbox';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@radix-ui/react-dialog';
import {DialogDescription, DialogHeader} from '../dialog/dialog';
import {Button} from '../primitives/button/button';
import {Input} from '../primitives/imput/input';

interface ApartsmentFinishingItemProps {
  apartment: Apartment;
  handleApartmentClick: (item: Apartment) => void;
}

interface Apartment {
  image: string;
  title: string;
  price: string;
  commonSpace: string;
  livingSpace: string;
  dialogTitle: string;
}

export const ApartmentsFinishingItem = ({
                                          apartment,
                                          handleApartmentClick,
                                        }: ApartsmentFinishingItemProps) => {
  return (
    <div className="grid py-5 bg-plt-black/5 shadow-lg rounded-[20px] font-open-sans">
      <div className="w-full flex justify-center items-center h-[240px]">
        <img
          src={apartment.image}
          alt={apartment.title}
          className="object-scale-down w-full h-full"
        />
      </div>
      <h5 className="text-center text-plt-black font-semibold leading-[120%] mt-2">
        {apartment.title}
      </h5>
      <p className="text-center text-[#828081] text-xs font-semibold leading-[120%] mt-3">
        Жилая площадь: <span>{apartment.livingSpace}</span>
      </p>
      <Button
        onClick={() => handleApartmentClick(apartment)}
        className="mt-6 mx-[30px] font-semibold text-plt-white"
      >
        Узнать стоимость
      </Button>
    </div>
  );
};
